import React, { useState, useEffect } from "react";
import Navbar from "./components/Navbar";
import DownloadAppAssociats from "./components/DownloadAppAssociats";
import Newsletter from "./components/NewsLetter";
import Footer from "./components/Footer";
// React Icons import
import { FaCloud, FaPalette, FaSlidersH, FaBuilding } from "react-icons/fa";
// Images for Header Carousel
import assoc1 from "../images/associate1.jpg";
import assoc2 from "../images/associate2.jpg";
import assoc3 from "../images/associate3.jpg";
// Unique images for the tab cards (Admission, Content, Exam, Admin, Console)
import adm1 from "../images/aden1.png";
import adm2 from "../images/aden2.png";
import adm3 from "../images/aden3.png";
import adm4 from "../images/aden4.png";
import adm5 from "../images/aden5.png";
import cont1 from "../images/content1.png";
import cont2 from "../images/content2.png";
import cont3 from "../images/content3.png";
import cont4 from "../images/content4.png";
import cont5 from "../images/content5.png";
import exam1 from "../images/exam1.png";
import exam2 from "../images/exam2.png";
import exam3 from "../images/exam3.png";
import exam4 from "../images/exam4.png";
import exam5 from "../images/exam5.png";
import admin1 from "../images/admin1.png";
import admin2 from "../images/admin2.png";
import admin3 from "../images/admin3.png";
import admin4 from "../images/admin4.png";
import admin5 from "../images/admin5.png";
// Reusing admin assets for Console tab or you can map dedicated assets
import circlesBg from "../images/Banner2.png";
import "./css/Associates.css";
import Swal from "sweetalert2";

function Associates() {
    const images = [assoc1, assoc2, assoc3];
    const [currentIndex, setCurrentIndex] = useState(0);
    const [activeTab, setActiveTab] = useState("admission");
    // State for the Partnership Model Tabs ("crestest" or "custom")
    const [modelTab, setModelTab] = useState("crestest");

    // Handle deep-linked anchoring via URL hash (e.g., /associates#content)
    useEffect(() => {
        const handleHashChange = () => {
            const hash = window.location.hash.replace("#", "").toLowerCase();
            const validTabs = ["admission", "content", "exam", "admin", "console"];
            if (validTabs.includes(hash)) {
                setActiveTab(hash);
            }
        };

        // Check hash on initial load
        handleHashChange();

        // Listen for hash changes
        window.addEventListener("hashchange", handleHashChange);
        return () => window.removeEventListener("hashchange", handleHashChange);
    }, []);

    // Function to change tab, update hash, and scroll down smoothly
    // const handleTabChange = (tabKey) => {
    //     setActiveTab(tabKey);
    //     window.location.hash = tabKey;

    //     // Smooth scroll to the ecosystem section
    //     const section = document.getElementById("ecosystem-section");
    //     if (section) {
    //         section.scrollIntoView({ behavior: "smooth" });
    //     }
    // };

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
        }, 3500);
        return () => clearInterval(timer);
    }, [images.length]);

    const getPrevIndex = (index) => (index - 1 + images.length) % images.length;
    const getNextIndex = (index) => (index + 1) % images.length;

    // Data mapped for the tabs
    const tabData = {
        exam: [
            {
                title: "Exam Scheduling",
                desc: "Manage examinations efficiently",
                points: [
                    "Unified view of all exam deadlines and time slots.",
                    "Automated flagging and resolution of scheduling clashes.",
                    "Precise control over exam duration and submission windows.",
                    "Automatic alerts to students, invigilators, and faculty."
                ],
                img: exam1
            },
            {
                title: "Question Bank",
                desc: "Smart paper preparation",
                points: [
                    "Draw questions based on weighted difficulty and topic.",
                    "Assign authorship while maintaining central oversight.",
                    "Create questions with text, images, and rich media.",
                    "Ensure uniformity across all subject question papers."
                ],
                img: exam2
            },
            {
                title: "Paper Review",
                desc: "Finalize examinations",
                points: [
                    "Instantly view final paper layout before publication.",
                    "Precisely define mark schemes and partial credit rules.",
                    "Log all edits and version changes for transparency.",
                    "Generate detailed internal paper versions with answer keys."
                ],
                img: exam3
            },
            {
                title: "Online Examination",
                desc: "Secure digital assessments",
                points: [
                    "Time-bound access verified by digital credentials.",
                    "Optional malpractice prevention features.",
                    "Continuous progress auto-save for minimal disruption.",
                    "Real-time status monitoring for invigilators."
                ],
                img: exam4
            },
            {
                title: "Evaluation",
                desc: "Accurate & efficient marking",
                points: [
                    "Instant evaluation of objective questions.",
                    "Anonymous marking for subjective answers.",
                    "Distribute answer sheets for parallel evaluation.",
                    "Digital scoring parameters for consistent assessment."
                ],
                img: exam5
            }
        ],
        content: [
            {
                title: "Content Creation",
                desc: "Develop engaging learning resources",
                points: [
                    "Create content using rich media and academic formats.",
                    "Structured digital review by subject matter experts.",
                    "Centralized control over content permissions and usage.",
                    "Instant sharing to relevant student groups or standards."
                ],
                img: cont1
            },
            {
                title: "Content Library",
                desc: "Centralized resource management",
                points: [
                    "Tag content by subject, chapter, and standard.",
                    "Centralized, secure library for all approved resources.",
                    "Quick identification and redeployment of learning assets.",
                    "Powerful filters for fast, precise content retrieval."
                ],
                img: cont5
            },
            {
                title: "Media Streaming",
                desc: "Optimized digital delivery",
                points: [
                    "Automatic conversion for best playback quality on all devices.",
                    "Content protection from unauthorized download or sharing.",
                    "Adaptive streaming ensures performance across varied networks.",
                    "High-availability hosting for constant lecture access."
                ],
                img: cont2
            },
            {
                title: "Content Analytics",
                desc: "Track learning engagement",
                points: [
                    "Log student view time and content completion status.",
                    "Visual reporting on resource access and popularity.",
                    "Automated alerts for students with low content engagement.",
                    "Real-time metrics for resource effectiveness."
                ],
                img: cont3
            },
            {
                title: "Assignments",
                desc: "Digital submission & review",
                points: [
                    "Delegate tasks by chapter or individual student needs.",
                    "Secure portal for student assignment uploads.",
                    "Integrated tools ensure academic integrity.",
                    "Timely annotated reviews by teachers."
                ],
                img: cont4
            }
        ],
        admission: [
            {
                title: "Admission Enquiry",
                desc: "Your future starts here",
                points: [
                    "Start your journey from any platform—mobile, desktop, or social media.",
                    "Designed to ensure a frictionless start to your process. Get your enquiry submitted in seconds!",
                    "Ensures your query is acknowledged immediately. You'll never be left waiting.",
                    "Experience a streamlined admissions pathway for fast, accurate follow-up from our team."
                ],
                img: adm1
            },
            {
                title: "Application Form",
                desc: "Simple & guided application",
                points: [
                    "Guided interface ensures 100% accuracy and completion.",
                    "Session management keeps your progress secured and instantly accessible from any device.",
                    "Secure document upload for all academic credentials.",
                    "Real-time status tracking of your application review."
                ],
                img: adm2
            },
            {
                title: "Interview Process",
                desc: "Transparent evaluation",
                points: [
                    "Seamlessly book and confirm your interview slot online.",
                    "A two-way conversation to ensure mutual fit.",
                    "Holistic evaluation of leadership, character, and skills.",
                    "Decision transparency with timely feedback and final notification."
                ],
                img: adm3
            },
            {
                title: "Fee Payment",
                desc: "Secure digital transactions",
                points: [
                    "Secure gateway processes all payments with maximum data security.",
                    "Flexible options let you choose from multiple payment modes.",
                    "Instant receipt generation upon successful completion.",
                    "Complete payment history available in your dashboard."
                ],
                img: adm4
            },
            {
                title: "Student Onboarding",
                desc: "Ready for your academic journey",
                points: [
                    "Personalized orientation kit and schedule available.",
                    "Digital credentialing with student ID and official Crestest email.",
                    "Community integration through student forums and peer programs.",
                    "Resource hub with schedule, fee ledger, and campus information."
                ],
                img: adm5
            }
        ],
        admin: [
            {
                title: "User Access Management",
                desc: "Secure administrative control",
                points: [
                    "Outline precise system access based on user designation.",
                    "Automatically customize dashboards per user function.",
                    "Streamline staff onboarding, modification, and offboarding.",
                    "Enforce strong security policies with multi-factor authentication."
                ],
                img: admin1
            },
            {
                title: "Task Management",
                desc: "Efficient administrative workflow",
                points: [
                    "Digitally delegate administrative duties to staff.",
                    "Built-in tools for internal alerts and secure coordination.",
                    "Automated transfer of high-priority or overdue tasks.",
                    "Distribute high-volume tasks across the team."
                ],
                img: admin2
            },
            {
                title: "System Operations",
                desc: "Automate daily administration",
                points: [
                    "Execute actions on large datasets simultaneously.",
                    "Centralized tools for creating and deploying digital forms.",
                    "Automate routine backup and archival processes.",
                    "Personalize administrative views and reports."
                ],
                img: admin3
            },
            {
                title: "Student Management",
                desc: "Complete student oversight",
                points: [
                    "Single view of academic, financial, and engagement data.",
                    "Instant access to scores and class standings.",
                    "Segment students by program or performance metrics.",
                    "Track portal activity and communication history."
                ],
                img: admin4
            },
            {
                title: "Data Security",
                desc: "Enterprise-grade protection",
                points: [
                    "Industry-standard encryption for sensitive data.",
                    "Comprehensive audit logs for every interaction.",
                    "Compliance with local and international privacy laws.",
                    "Automated backup and disaster recovery."
                ],
                img: admin5
            }
        ]
    };

    useEffect(() => {
        const handleHashChange = () => {
            const hash = window.location.hash.replace("#", "").toLowerCase();
            const validTabs = ["admission", "content", "exam", "admin", "console"];
            if (validTabs.includes(hash)) {
                setActiveTab(hash);
                const section = document.getElementById("ecosystem-section");
                if (section) {
                    section.scrollIntoView({ behavior: "smooth" });
                }
            }
        };

        handleHashChange();
        window.addEventListener("hashchange", handleHashChange);
        return () => window.removeEventListener("hashchange", handleHashChange);
    }, []);

    // Function to handle tab selection and smooth scrolling
    const handleTabChange = (tabKey) => {
        if (tabKey === "console") {
            // Trigger SweetAlert popup for console warning instead of changing tab
            Swal.fire({
                title: '<span style="color: #FBBB1B;">⚠️ Restricted Access</span>',
                html: '<p style="color: #cbd5e1; font-size: 1rem;">This portal is strictly for <b>internal use only</b>. Unauthorized access is monitored.</p>',
                background: "rgba(8, 20, 40, 0.95)",
                backdrop: `
                    rgba(15, 23, 42, 0.8)
                    backdrop-filter: blur(12px);
                    -webkit-backdrop-filter: blur(12px);
                `,
                confirmButtonText: "Go to Console",
                confirmButtonColor: "#207AB4",
                showCancelButton: true,
                cancelButtonText: "Cancel",
                cancelButtonColor: "#475569",
                customClass: {
                    popup: "crestest-prereg-swal"
                }
            }).then((result) => {
                if (result.isConfirmed) {
                    window.open("https://console.crestest.com/", "_blank");
                }
            });
            return;
        }

        setActiveTab(tabKey);
        window.location.hash = tabKey;

        const section = document.getElementById("ecosystem-section");
        if (section) {
            section.scrollIntoView({ behavior: "smooth" });
        }
    };



    return (
        <div className="associates-page-wrapper">
            {/* Header with Navbar */}
            <header className="associates-header-section">
                <div className="associates-hero-container">
                    <Navbar />
                    <div className="container text-center py-3">
                        <span className="badge px-3 py-1 rounded-pill fw-bold mb-2" style={{ backgroundColor: '#FBBB1B', color: '#1e293b' }}>
                            Our Associative Program
                        </span>
                        <h1 className="fw-bold text-white display-6 mb-2">
                            CRESTEST ASSOCIATIVE ACADEMIC ERP
                        </h1>
                        <p
                            className="text-white-50 mx-auto mb-4"
                            style={{ maxWidth: '1200px', fontSize: '1.45rem' }}
                        >
                            A complete academic and institutional management system for schools and institutes,
                            offered on a flexible rental basis with the technology, support, and features you need.
                        </p>
                        {/* Circular Overlapping Image Carousel Animation */}
                        <div className="associates-carousel-stage">
                            <div className="associates-carousel-track">
                                <div className="assoc-card side-card left-card">
                                    <img src={images[getPrevIndex(currentIndex)]} alt="Previous Associate" className="img-fluid rounded-4 shadow" />
                                </div>
                                <div className="assoc-card center-card shadow-lg">
                                    <img src={images[currentIndex]} alt="Current Featured Associate" className="img-fluid rounded-4" />
                                </div>
                                <div className="assoc-card side-card right-card">
                                    <img src={images[getNextIndex(currentIndex)]} alt="Next Associate" className="img-fluid rounded-4 shadow" />
                                </div>
                            </div>
                            <div className="carousel-dots mt-3">
                                {images.map((_, idx) => (
                                    <button
                                        key={idx}
                                        className={`dot-indicator ${currentIndex === idx ? 'active' : ''}`}
                                        onClick={() => setCurrentIndex(idx)}
                                        aria-label={`Slide ${idx + 1}`}
                                    ></button>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            {/* Main Content Info Container */}
            <main className="container my-5 py-4">
                <div className="row justify-content-center">
                    <div className="col-lg-8">
                        <div className="card shadow-sm border-0 rounded-4 p-4 p-md-5 text-center bg-white">
                            <h2 className="fw-bold mb-4" style={{ color: '#207AB4' }}>
                                Empowering Institutions with Smart ERP
                            </h2>

                            <p className="text-muted lh-lg fs-6 mb-0">
                                <strong>Crestest Associative Academic ERP</strong> provides schools and
                                educational institutes with a complete digital management system on a
                                flexible rental and association basis. Institutions can access the
                                technology they need to manage academics, students, examinations,
                                administration, communication, and other essential operations through
                                one integrated platform—without the need to build and maintain their
                                own ERP infrastructure.
                            </p>
                        </div>
                    </div>
                </div>
            </main>

            {/* NEW PARTNERSHIP MODELS SECTION */}
            <section className="py-5 bg-white">
                <div className="container py-4 text-center">
                    {/* Small Text */}
                    <span className="badge px-3 py-1 rounded-pill fw-bold mb-2" style={{ backgroundColor: '#FBBB1B', color: '#1e293b' }}>
                        Flexible Partnerships
                    </span>

                    {/* Heading Text */}
                    <h2 className="fw-bold display-6 mb-3" style={{ color: '#207AB4' }}>
                        Choose Your Integration Framework
                    </h2>

                    {/* Sub Text */}
                    <p className="text-muted mx-auto mb-5" style={{ maxWidth: '750px' }}>
                        Tailor your institute’s digital infrastructure with our ready-to-deploy ecosystem or customized modular solutions designed for your specific scale.
                    </p>

                    {/* Center Aligned Two Tabs */}
                    <div className="d-flex justify-content-center gap-3 mb-5">
                        <button
                            onClick={() => setModelTab("crestest")}
                            className={`btn px-4 py-2 rounded-pill fw-bold shadow-sm`}
                            style={{
                                backgroundColor: modelTab === "crestest" ? '#207AB4' : '#f8f9fa',
                                color: modelTab === "crestest" ? '#ffffff' : '#207AB4',
                                border: '1px solid #207AB4'
                            }}
                        >
                            Crestest Model
                        </button>
                        <button
                            onClick={() => setModelTab("custom")}
                            className={`btn px-4 py-2 rounded-pill fw-bold shadow-sm`}
                            style={{
                                backgroundColor: modelTab === "custom" ? '#207AB4' : '#f8f9fa',
                                color: modelTab === "custom" ? '#ffffff' : '#207AB4',
                                border: '1px solid #207AB4'
                            }}
                        >
                            Custom Model
                        </button>
                    </div>

                    {/* Tab Content Area */}
                    {modelTab === "crestest" ? (
                        <div>
                            {/* 4 Bordered Boxes - 2 boxes in each row */}
                            <div className="row g-4 justify-content-center mb-5 text-start">
                                {/* Box 1 */}
                                <div className="col-lg-6">
                                    <div className="p-4 border rounded-4 shadow-sm h-100 bg-light d-flex align-items-start gap-3">
                                        <div className="fs-3 text-warning p-2 rounded bg-white shadow-sm">
                                            <i className="bi bi-laptop"></i>
                                        </div>
                                        <div>
                                            <h5 className="fw-bold mb-2" style={{ color: '#207AB4' }}>
                                                Complete LMS Portal
                                            </h5>
                                            <p className="text-muted small mb-0">
                                                Provide students with a complete digital learning environment
                                                for accessing courses, assessments, practice resources, and
                                                academic content. The platform supports bulk student enrollment,
                                                centralized management, progress tracking, and continuous
                                                learning engagement.
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                {/* Box 2 */}
                                <div className="col-lg-6">
                                    <div className="p-4 border rounded-4 shadow-sm h-100 bg-light d-flex align-items-start gap-3">
                                        <div className="fs-3 text-warning p-2 rounded bg-white shadow-sm">
                                            <i className="bi bi-file-earmark-text"></i>
                                        </div>
                                        <div>
                                            <h5 className="fw-bold mb-2" style={{ color: '#207AB4' }}>
                                                Custom Online Exams
                                            </h5>
                                            <p className="text-muted small mb-0">
                                                Conduct secure and structured online examinations tailored to
                                                your institution's academic requirements. Create customized
                                                assessments, manage question sets, automate evaluation, and
                                                provide students with timely results and performance insights.
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                {/* Box 3 */}
                                <div className="col-lg-6">
                                    <div className="p-4 border rounded-4 shadow-sm h-100 bg-light d-flex align-items-start gap-3">
                                        <div className="fs-3 text-warning p-2 rounded bg-white shadow-sm">
                                            <i className="bi bi-journal-bookmark"></i>
                                        </div>
                                        <div>
                                            <h5 className="fw-bold mb-2" style={{ color: '#207AB4' }}>
                                                E-Library & Concept Maps
                                            </h5>
                                            <p className="text-muted small mb-0">
                                                Give learners access to organized digital study resources,
                                                reference materials, and visual concept maps that make complex
                                                topics easier to understand. Support independent learning,
                                                revision, concept clarity, and stronger academic retention.
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                {/* Box 4 */}
                                <div className="col-lg-6">
                                    <div className="p-4 border rounded-4 shadow-sm h-100 bg-light d-flex align-items-start gap-3">
                                        <div className="fs-3 text-warning p-2 rounded bg-white shadow-sm">
                                            <i className="bi bi-book"></i>
                                        </div>
                                        <div>
                                            <h5 className="fw-bold mb-2" style={{ color: '#207AB4' }}>
                                                Curated Write-Ups & Assets
                                            </h5>
                                            <p className="text-muted small mb-0">
                                                Access a growing collection of professionally curated academic
                                                write-ups, learning materials, practice resources, and digital
                                                assets. These resources can be seamlessly made available to
                                                your student community as part of the institutional learning
                                                ecosystem.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Description text overview */}
                            <p className="text-muted mx-auto mb-4 small" style={{ maxWidth: '800px' }}>
                                In the Crestest model we are providing our own Crestest LMS (Learning Management System portal) along with its custom online exams and e-library, concept maps, and writeups everything to the bulk students of a school or institution. If they want, they can subscribe that for their school or institute. All Crestest own contents will be accessible to the students of that subscribed school or institute.
                            </p>

                            {/* Center Aligned Subscribe Button */}
                            <div className="text-center">
                                <a
                                    href="https://console.crestest.com"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn px-5 py-3 rounded-pill fw-bold shadow text-white"
                                    style={{ backgroundColor: '#207AB4' }}
                                >
                                    Subscribe
                                </a>
                            </div>
                        </div>
                    ) : (
                        <div>
                            {/* 4 Boxes in a Single Row using React Icons */}
                            <div className="row g-4 justify-content-center mb-5 text-start">
                                {/* Box 1 */}
                                <div className="col-lg-3 col-md-6">
                                    <div className="p-4 border rounded-4 shadow-sm h-100 bg-light text-center">
                                        <div className="mb-3 fs-2" style={{ color: '#207AB4' }}>
                                            <FaCloud />
                                        </div>
                                        <h5 className="fw-bold mb-2 fs-6" style={{ color: '#207AB4' }}>Rental Basis ERP Deployment</h5>
                                        <p className="text-muted small mb-0">
                                            Get full access to our custom academic ERP on a flexible rental structure built for immediate campus integration.
                                        </p>
                                    </div>
                                </div>

                                {/* Box 2 */}
                                <div className="col-lg-3 col-md-6">
                                    <div className="p-4 border rounded-4 shadow-sm h-100 bg-light text-center">
                                        <div className="mb-3 fs-2" style={{ color: '#207AB4' }}>
                                            <FaPalette />
                                        </div>
                                        <h5 className="fw-bold mb-2 fs-6" style={{ color: '#207AB4' }}>Fully Customized Branding</h5>
                                        <p className="text-muted small mb-0">
                                            Tailor the system completely to match your institution's specific requirements, workflows, and school branding.
                                        </p>
                                    </div>
                                </div>

                                {/* Box 3 */}
                                <div className="col-lg-3 col-md-6">
                                    <div className="p-4 border rounded-4 shadow-sm h-100 bg-light text-center">
                                        <div className="mb-3 fs-2" style={{ color: '#207AB4' }}>
                                            <FaSlidersH />
                                        </div>
                                        <h5 className="fw-bold mb-2 fs-6" style={{ color: '#207AB4' }}>Flexible Operational Terms</h5>
                                        <p className="text-muted small mb-0">
                                            Choose scalable rental agreements or full permanent ownership options depending on your institutional roadmap.
                                        </p>
                                    </div>
                                </div>

                                {/* Box 4 */}
                                <div className="col-lg-3 col-md-6">
                                    <div className="p-4 border rounded-4 shadow-sm h-100 bg-light text-center">
                                        <div className="mb-3 fs-2" style={{ color: '#207AB4' }}>
                                            <FaBuilding />
                                        </div>
                                        <h5 className="fw-bold mb-2 fs-6" style={{ color: '#207AB4' }}>Permanent Purchase Options</h5>
                                        <p className="text-muted small mb-0">
                                            Buy the complete custom framework permanently for your school or institute with full ownership flexibility.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* Description text overview */}
                            <p className="text-muted mx-auto mb-4 small" style={{ maxWidth: '800px' }}>
                                In this custom model we will give our custom academic ERP to the school or institute for use on a rental basis, or else schools can take them fully customized as per their requirement or as per their school's or institute's branding. Both rental bases or permanent purchase options are available.
                            </p>

                            {/* Center Aligned Subscribe Button */}
                            <div className="text-center">
                                <a
                                    href="https://console.crestest.com"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn px-5 py-3 rounded-pill fw-bold shadow text-white"
                                    style={{ backgroundColor: '#207AB4' }}
                                >
                                    Subscribe
                                </a>
                            </div>
                        </div>
                    )}
                </div>
            </section>

            {/* Download App Section */}
            <DownloadAppAssociats />

            {/* Light Background Section with 3 Cards per Row Layout */}
            <section
                id="ecosystem-section"
                className="position-relative py-5 text-dark bg-light-section"
                style={{ backgroundImage: `url(${circlesBg})` }}
            >
                <div className="container text-center py-4 position-relative z-2">
                    <span className="badge px-3 py-1 rounded-pill fw-bold mb-2 shadow-sm" style={{ backgroundColor: '#207AB4', color: '#ffffff' }}>
                        Ecosystem Overview
                    </span>
                    <h2 className="fw-bold display-6 mb-3" style={{ color: '#207AB4' }}>Comprehensive Institutional Support</h2>
                    <p className="text-muted mx-auto mb-5" style={{ maxWidth: '650px' }}>
                        Explore our multi-faceted modules built specifically to streamline campus operations and elevate learning outcomes.
                    </p>

                    {/* Reordered Tabs Navigation: Exam, Content, Admission, Admin, Console */}
                    <div className="d-flex justify-content-center flex-wrap gap-2 mb-5">
                        {[
                            { key: 'exam', label: 'Exam' },
                            { key: 'content', label: 'Content' },
                            { key: 'admission', label: 'Admission' },
                            { key: 'admin', label: 'Admin' },
                            { key: 'console', label: 'Console' }
                        ].map((tab) => (
                            <button
                                key={tab.key}
                                onClick={() => handleTabChange(tab.key)}
                                className={`btn px-4 py-2 rounded-pill fw-bold transition-all ${activeTab === tab.key ? 'shadow' : ''}`}
                                style={{
                                    backgroundColor: activeTab === tab.key ? '#207AB4' : '#ffffff',
                                    color: activeTab === tab.key ? '#ffffff' : '#207AB4',
                                    border: '1px solid #207AB4'
                                }}
                            >
                                {tab.label}
                            </button>
                        ))}
                    </div>

                    {/* Cards layout */}
                    <div className="row g-4 justify-content-center">
                        {tabData[activeTab]?.map((card, idx) => (
                            <div className="col-lg-4 col-md-6" key={idx}>
                                <div className="card h-100 border-0 rounded-4 shadow-sm bg-white text-dark p-4 text-start">
                                    <div className="card-img-wrapper mb-3 overflow-hidden rounded-3 shadow-sm" style={{ height: '180px' }}>
                                        <img src={card.img} alt={card.title} className="w-100 h-100 object-fit-cover" />
                                    </div>
                                    <h5 className="fw-bold mb-1" style={{ color: '#207AB4' }}>{card.title}</h5>
                                    <p className="text-muted small mb-3">{card.desc}</p>
                                    <ul className="list-unstyled mb-0 small text-secondary">
                                        {card.points.map((pt, pIdx) => (
                                            <li key={pIdx} className="mb-2 d-flex align-items-center">
                                                <span className="me-2 fw-bold" style={{ color: '#FBBB1B' }}>•</span> {pt}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Newsletter Section */}
            <Newsletter />
            {/* Footer */}
            <Footer />
        </div>
    );
}

export default Associates;